export default __webpack_public_path__ + "static/media/logo2.c8882734.png";